var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],class:_vm.className},[_c('section',{staticClass:"tab-pane tabs-component-panel",class:{'active': _vm.isActive},attrs:{"aria-hidden":!_vm.isActive,"id":_vm.hash,"role":"tabpanel"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }